import { Box, Paper, Typography, Avatar } from "@mui/material"
import { Person, HomeWork, Star } from "@mui/icons-material"
import Grid from '@mui/material/Grid2';

interface PropertyHunterInfoProps {
  hunter: any
}

const PropertyHunterInfo = ({ hunter }: PropertyHunterInfoProps) => {
  return (
    <Box sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h6" sx={{ mt: 2, mb: 3, fontWeight: "bold", display: "flex", alignItems: "center" }}>
        <Person sx={{ mr: 1, color: "#4caf50" }} /> Información del Hunter
      </Typography>

      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: "12px",
          background: "linear-gradient(145deg, #ffffff, #f5f5f5)",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
        }}
      >
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <Avatar
                src={hunter.hunterProfileImage || "/assets/images/profilePicture.png"}
                alt={hunter.hunterFullName}
                sx={{
                  width: 120,
                  height: 120,
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                  border: "3px solid white",
                  mb: 2,
                }}
              />
              <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center" }}>
                {hunter.hunterFullName}
              </Typography>

              {hunter.hunterRating && (
                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      sx={{
                        fontSize: 20,
                        color: i < Math.floor(hunter.hunterRating!) ? "#FFD700" : "#e0e0e0",
                      }}
                    />
                  ))}
                  <Typography variant="body2" sx={{ ml: 0.5, color: "#757575" }}>
                    ({hunter.hunterRating})
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>

          <Grid size={{ xs: 12, md: 8 }}>
            <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <Box sx={{ mb: 3 }}>
                <Typography variant="subtitle1" sx={{ color: "#757575", mb: 0.5 }}>
                  Email
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                  {hunter.hunterEmail || "No disponible"}
                </Typography>
              </Box>

              <Box>
                <Typography variant="subtitle1" sx={{ color: "#757575", mb: 0.5 }}>
                  Propiedades Descubiertas
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <HomeWork sx={{ color: "#4caf50", mr: 1 }} />
                  <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                    {hunter.hunterPropertiesUploadedCount || 0} propiedades
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  mt: 3,
                  p: 2,
                  borderRadius: "8px",
                  bgcolor: "rgba(76, 175, 80, 0.05)",
                  border: "1px dashed #4caf50",
                }}
              >
                <Typography variant="body2" sx={{ fontStyle: "italic", color: "#4caf50" }}>
                  Este hunter ha descubierto esta propiedad y la ha compartido con nuestro equipo de brokers.
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>
      <Box
        sx={{
          height: "60px",
          display: { xs: "block", sm: "none" },
          width: "100%",
        }}
      />
    </Box>
  )
}

export default PropertyHunterInfo
